import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33671cc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 mw-600px mx-auto mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 mb-10 text-start" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 text-dark required" }, "Rows", -1))
const _hoisted_5 = {
  key: 0,
  class: "fv-plugins-message-container text-start"
}
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "col-6 mb-10 text-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 text-dark required" }, "Columns(Max 6)", -1))
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container text-start"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "fv-row mb-10 text-start" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 text-dark" }, "Templates", -1))
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container text-start"
}
const _hoisted_14 = { class: "fv-help-block" }


// export default {
//   inheritAttrs: false,
// };

import { defineComponent, defineEmits, ref } from "vue";
import VZModal from "@/components/content/VZModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { useField, useForm } from "vee-validate";
import { object, number } from "yup";
const __default__ = defineComponent({
  name: "EmptyContent",
  components: {
    VZModal,
  },
  emit: ["close-initial-modal"],
  props: {
    showDialog: { type: Boolean, default: false },
    templateOptions: {
      type: Array as () => Array<{ label: string; value: string }>,
      default: () => [],
    },
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: {
  "create-table": ({ row, column, template }) => {
    if ((row && column) || template) {
      return true;
    } else {
      return false;
    }
  },
},
  setup(__props, { emit }) {


function t(key: string) {
  return TranslationService.translate(key);
}
const schema = object({
  column: number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .max(6)
    .required("Column is required"),
  row: number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .max(50)
    .required("Row is required"),
  template: number().required(),
});
const { errors, validate } = useForm({
  validationSchema: schema,
  initialValues: {
    column: 2,
    row: 2,
    template: 0,
  },
});
const { value: column } = useField("column");
const { value: row } = useField("row");

const template = ref();
const createForm = () => {
  validate()
    .then((validationResult) => {
      if (!validationResult.valid) {
        return;
      }
      emit("create-table", { row, column, template });
    })
    .catch((err) => {
      console.error(err);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(VZModal, {
      title: 'Add Columns and Rows',
      id: `vz_add_column_row`,
      widthClass: 'width-650',
      showDialog: _ctx.showDialog,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close-initial-modal')))
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close-initial-modal')))
        }, " Close "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
          onClick: createForm
        }, " Confirm ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                onkeydown: "if(event.key==='.'){event.preventDefault();}",
                oninput: "event.target.value = event.target.value.replace(/[^0-9]*/g,'');",
                name: "row",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(row) ? (row).value = $event : null)),
                min: "0",
                max: "50"
              }, null, 512), [
                [_vModelText, _unref(row)]
              ]),
              (_unref(errors).row)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(_unref(errors).row), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                name: "row",
                onkeydown: "if(event.key==='.'){event.preventDefault();}",
                oninput: "event.target.value = event.target.value.replace(/[^0-9]*/g,'');",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(column) ? (column).value = $event : null)),
                min: "0",
                max: "6"
              }, null, 512), [
                [_vModelText, _unref(column)]
              ]),
              (_unref(errors).column)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_unref(errors).column), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              placeholder: "Select Template",
              label: "label",
              value: "value",
              class: "w-100",
              name: "template",
              clearable: "",
              filterable: "",
              modelValue: template.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((template).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateOptions, (option, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: option.label,
                    value: option.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_unref(errors).template)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_unref(errors).template), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}
}

})